import { Outlet } from 'react-router-dom'

const ClientsPage = () => (
  <Outlet />
)

export default ClientsPage
